/* =========================================================
   SOLAYA — Shopify product page interactions
   Vanilla JS, no external deps.
   ========================================================= */
(function () {
  "use strict";
  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* ---------- Scroll reveal ---------- */
  function initReveal(root) {
    const reveals = $$("[data-reveal]", root);
    if (!reveals.length) return;
    let first = true;
    function check() {
      const trigger = window.innerHeight * 0.92;
      const just = [];
      for (const el of reveals) {
        if (el.classList.contains("is-in")) continue;
        if (el.getBoundingClientRect().top < trigger) { el.classList.add("is-in"); just.push(el); }
      }
      if (first && just.length) {
        just.forEach((el) => (el.style.transition = "none"));
        void document.body.offsetWidth;
        requestAnimationFrame(() => just.forEach((el) => (el.style.transition = "")));
      }
      first = false;
    }
    check();
    window.addEventListener("scroll", check, { passive: true });
    window.addEventListener("resize", check);
  }

  /* ---------- Product gallery ---------- */
  function initGallery(root) {
    const main   = $("[data-gallery-main]", root);
    if (!main) return;
    const slides = $$("[data-gallery-slide]", root);
    const thumbs = $$("[data-gallery-thumb]", root);
    const prev   = $("[data-gallery-prev]", root);
    const next   = $("[data-gallery-next]", root);
    let cur = slides.findIndex(s => s.classList.contains("is-active"));
    if (cur < 0) cur = 0;

    function setImg(i) {
      if (!slides.length) return;
      cur = (i + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle("is-active", k === cur));
      thumbs.forEach((t, k) => t.classList.toggle("is-active", k === cur));
    }
    thumbs.forEach((t, i) => t.addEventListener("click", () => setImg(i)));
    if (prev) prev.addEventListener("click", () => setImg(cur - 1));
    if (next) next.addEventListener("click", () => setImg(cur + 1));

    // Desktop hover-zoom
    const imgWrap = $("[data-gallery-img]", main) || main;
    main.addEventListener("mousemove", (e) => {
      if (window.innerWidth < 760) return;
      const r = main.getBoundingClientRect();
      imgWrap.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
    });
    main.addEventListener("mouseenter", () => { if (window.innerWidth >= 760) main.classList.add("is-zoom"); });
    main.addEventListener("mouseleave", () => main.classList.remove("is-zoom"));

    // Mobile swipe
    let sx = 0;
    main.addEventListener("touchstart", (e) => (sx = e.touches[0].clientX), { passive: true });
    main.addEventListener("touchend", (e) => {
      const dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) setImg(cur + (dx < 0 ? 1 : -1));
    });
  }

  /* ---------- Quantity stepper ---------- */
  function initQty(root) {
    $$("[data-qty]", root).forEach((qty) => {
      const input = $("[data-qty-input]", qty);
      const minus = $("[data-qty-minus]", qty);
      const plus  = $("[data-qty-plus]", qty);
      if (!input) return;
      const min = parseInt(input.min || "1", 10) || 1;
      const max = parseInt(input.max || "99", 10) || 99;
      if (minus) minus.addEventListener("click", () => {
        input.value = Math.max(min, (parseInt(input.value, 10) || min) - 1);
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
      if (plus) plus.addEventListener("click", () => {
        input.value = Math.min(max, (parseInt(input.value, 10) || min) + 1);
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  }

  /* ---------- Variant picker (custom UI -> hidden form input) ---------- */
  function initVariantPicker(form) {
    if (!form) return;
    const productJsonEl = $("[data-product-json]", form);
    if (!productJsonEl) return;
    let product;
    try { product = JSON.parse(productJsonEl.textContent); } catch (e) { return; }
    const hiddenInput = $("input[name='id']", form);
    if (!hiddenInput) return;

    const optsState = (product.options || []).map((_, i) => {
      const cur = $(`input[name='option${i+1}']:checked`, form);
      return cur ? cur.value : (product.variants[0] && product.variants[0].options[i]) || null;
    });

    function matchVariant() {
      return product.variants.find(v =>
        v.options.every((o, i) => o === optsState[i])
      );
    }

    function syncPriceTotal() {
      const v = matchVariant();
      const priceEl = $("[data-product-price]", form);
      const compareEl = $("[data-product-compare]", form);
      const totalEl = $("[data-atc-total]", form);
      const qtyInput = $("[data-qty-input]", form);
      if (v) {
        hiddenInput.value = v.id;
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.textContent = formatMoney(v.compare_at_price);
            compareEl.hidden = false;
          } else compareEl.hidden = true;
        }
        const qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
        if (totalEl) totalEl.textContent = formatMoney(v.price * qty);

        const atcBtn = $("[data-atc]", form);
        if (atcBtn) {
          if (v.available) { atcBtn.removeAttribute("disabled"); $("span", atcBtn) && ($("span", atcBtn).textContent = atcBtn.dataset.labelAdd || "Ajouter au panier"); }
          else { atcBtn.setAttribute("disabled", ""); $("span", atcBtn) && ($("span", atcBtn).textContent = atcBtn.dataset.labelSold || "Rupture de stock"); }
        }

        const sticky = document.querySelector("[data-sticky-text]");
        if (sticky) sticky.textContent = formatMoney(v.price * qty);
      }
    }

    $$("input[name^='option']", form).forEach((inp) => {
      inp.addEventListener("change", () => {
        const idx = parseInt(inp.name.replace("option",""), 10) - 1;
        optsState[idx] = inp.value;
        // update visual active state for pack-style options
        const groupName = inp.name;
        $$(`input[name='${groupName}']`, form).forEach((other) => {
          const lbl = other.closest(".pack, .variant-picker__opt");
          if (lbl) lbl.classList.toggle("is-active", other.checked);
        });
        syncPriceTotal();
      });
    });

    const qtyInput = $("[data-qty-input]", form);
    if (qtyInput) qtyInput.addEventListener("change", syncPriceTotal);

    // initial sync
    $$("input[name^='option']:checked", form).forEach((inp) => {
      const lbl = inp.closest(".pack, .variant-picker__opt");
      if (lbl) lbl.classList.add("is-active");
    });
    syncPriceTotal();
  }

  /* ---------- Money format (uses theme money_format if exposed) ---------- */
  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.solayaMoneyFormat || "€{{amount}}");
    }
    const n = (cents / 100).toLocaleString(document.documentElement.lang || "fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return n + " €";
  }

  /* ---------- Accordions (FAQ + product accordion) ---------- */
  function initAccordion(root, exclusive) {
    const items = $$("[data-accordion-item]", root);
    items.forEach((item) => {
      const btn = $("[data-accordion-q]", item);
      const a   = $("[data-accordion-a]", item);
      if (!btn || !a) return;
      btn.addEventListener("click", () => {
        const isOpen = item.classList.contains("is-open");
        if (exclusive) {
          items.forEach((it) => {
            it.classList.remove("is-open");
            const ans = $("[data-accordion-a]", it);
            if (ans) ans.style.maxHeight = null;
            const b = $("[data-accordion-q]", it);
            if (b) b.setAttribute("aria-expanded", "false");
          });
        }
        if (!isOpen) {
          item.classList.add("is-open");
          a.style.maxHeight = a.scrollHeight + "px";
          btn.setAttribute("aria-expanded", "true");
        } else if (!exclusive) {
          item.classList.remove("is-open");
          a.style.maxHeight = null;
          btn.setAttribute("aria-expanded", "false");
        }
      });
    });
  }

  /* ---------- Carousel arrows (testimonials) ---------- */
  function initCarousel(root) {
    $$("[data-carousel]", root).forEach((car) => {
      const track = $("[data-carousel-track]", car);
      if (!track) return;
      const first = track.firstElementChild;
      const gap = parseInt(getComputedStyle(track).columnGap || "20", 10) || 20;
      const step = () => (first ? first.getBoundingClientRect().width + gap : 320);
      const p = $("[data-carousel-prev]", car);
      const n = $("[data-carousel-next]", car);
      if (p) p.addEventListener("click", () => track.scrollBy({ left: -step(), behavior: "smooth" }));
      if (n) n.addEventListener("click", () => track.scrollBy({ left: step(),  behavior: "smooth" }));
    });
  }

  /* ---------- Before/after progress ---------- */
  function initBAProgress(root) {
    const track = $("[data-ba-track]", root);
    const bar   = $("[data-ba-progress]", root);
    if (!track || !bar) return;
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      const ratio = max > 0 ? track.scrollLeft / max : 0;
      const fill = 0.22;
      bar.style.width = fill * 100 + "%";
      bar.style.marginLeft = ratio * (1 - fill) * 100 + "%";
    };
    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  /* ---------- Sticky buy bar (mobile) ---------- */
  function initSticky() {
    const sticky = document.querySelector("[data-sticky-buy]");
    if (!sticky) return;
    const anchor = document.querySelector("[data-buybox-root]");
    if (!anchor) return;
    const check = () => {
      const past = anchor.getBoundingClientRect().bottom < 0;
      sticky.classList.toggle("is-visible", past && window.innerWidth < 960);
    };
    check();
    window.addEventListener("scroll", check, { passive: true });
    window.addEventListener("resize", check);

    // Make sticky CTA submit the real product form
    const cta = sticky.querySelector("[data-sticky-cta]");
    if (cta) cta.addEventListener("click", (e) => {
      const form = document.querySelector("#solaya-product-form");
      if (form) { e.preventDefault(); form.requestSubmit(); }
    });
  }

  /* ---------- Boot ---------- */
  function boot() {
    initReveal(document);
    initGallery(document);
    initQty(document);
    initVariantPicker(document.querySelector("#solaya-product-form"));
    initAccordion(document.querySelector("[data-pdp-accordion]"), false);
    document.querySelectorAll("[data-faq]").forEach(el => initAccordion(el, true));
    initCarousel(document);
    initBAProgress(document);
    initSticky();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
